'use client';
import { Heading as SharedHeading } from '@launchstore/shared-puck';
import type { HeadingProps } from '@launchstore/shared-puck';
export const Heading: any = SharedHeading;
export type { HeadingProps };
export default Heading;
